/**
 * Economy constants — must stay in sync with server/src/constants/economy.constants.js
 */

/** Coins awarded per day in the 7-Day Power Ladder (index = day - 1). */
export const DAILY_CLAIM_LADDER = [100, 125, 150, 200, 250, 300, 600] as const;

export const MAX_DAILY_CLAIM_COINS = DAILY_CLAIM_LADDER[DAILY_CLAIM_LADDER.length - 1];
